import BaseModel from "../base_model.js";

class RawPaymentTransactionModel extends BaseModel {

  i18nScope() {
    return "model.payments.transaction";
  }
}

const PaymentTransactionModel = new RawPaymentTransactionModel();

export { RawPaymentTransactionModel, PaymentTransactionModel }